import React, { useState, useEffect } from "react";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import NotificationSettingComponent from "../reusble_components/profile/Email";
import ChangePasswordForm from "../reusble_components/profile/changepassword";
import DisableAccount from "../reusble_components/profile/diableaccount";
import DeleteAccount from "../reusble_components/profile/deleteaccount";

const MoreSettings = () => {
  const { UserStore } = useStores();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEnabledForReminder, setIsEnabledForReminder] = useState(false);
  const [isEnabledForathunication, setIsEnabledForathunication] =
    useState(false);

  const getUserSetting = (settingName) => {
    return (
      Array.isArray(UserStore.userDetails?.additionalSettings) &&
      UserStore.userDetails?.additionalSettings?.find(
        (setting) => setting?.name === settingName
      )?.value
    );
  };

  useEffect(() => {
    setIsEnabled(getUserSetting("emailNotifications"));
    setIsEnabledForReminder(getUserSetting("reminderNotifications"));
    setIsEnabledForathunication(getUserSetting("2FactorAuthentication"));
  }, [UserStore.userDetails]);

  return useObserver(() => (
    <div className="flex flex-col border-t-2">
      <div className="mt-6 mx-6">
        <h2 className="text-black text-xl md:mb-5 lg:mb-5 mb-2 mt-3 font-bold">
          Additional Settings
        </h2>
        {/* <div className="flex md:flex-row lg:flex-row flex-col ml-0 gap-4 w-full md:pd-0 lg:pd-0 pb-4">
          <NotificationSettingComponent
            title={"Email Notifications"}
            description={
              "Control alerts for new candidate submissions, interviews, and messages."
            }
            Enabled={getUserSetting("emailNotifications")}
            onChange={async () => {
              let additionalSettings = Array.isArray(
                UserStore.userDetails?.additionalSettings
              )
                ? UserStore.userDetails?.additionalSettings
                : [];
              additionalSettings = additionalSettings?.filter(
                (setting) => setting?.name !== "emailNotifications"
              );

              // Get current value to toggle
              const currentValue =
                additionalSettings.find(
                  (setting) => setting?.name === "emailNotifications"
                )?.value ?? false;

              additionalSettings.push({
                name: "emailNotifications",
                value: !currentValue, // Toggle the value
              });

              const res = await UserStore.UpdateUserStatus({
                additionalSettings: additionalSettings,
              });

              if (res) {
                setIsEnabled(!currentValue); // Update state with new toggled value
              }
            }}
          />

          <NotificationSettingComponent
            title={"Reminder Notifications"}
            description={"Configure reminders for pending interviews or tasks"}
            Enabled={getUserSetting("reminderNotifications")}
            onChange={async () => {
              let additionalSettings = Array.isArray(
                UserStore.userDetails?.additionalSettings
              )
                ? UserStore.userDetails?.additionalSettings
                : [];
              additionalSettings = additionalSettings?.filter(
                (setting) => setting?.name !== "reminderNotifications"
              );
              additionalSettings.push({
                name: "reminderNotifications",
                value:
                  !UserStore.userDetails?.additionalSettings?.find(
                    (setting) => setting?.name === "reminderNotifications"
                  )?.value ?? false,
              });
              const res = await UserStore.UpdateUserStatus({
                additionalSettings: additionalSettings,
              });
              if (res) {
                setIsEnabledForReminder(
                  UserStore.userDetails.additionalSettings?.find(
                    (setting) => setting?.name === "reminderNotifications"
                  )?.value ?? false
                );
              }
            }}
          />

          <NotificationSettingComponent
            title={"Enable 2 Factor Authentication"}
            description={
              "Control alerts for new candidate submissions, interviews, and messages."
            }
            Enabled={getUserSetting("2FactorAuthentication")}
            onChange={async () => {
              let additionalSettings = Array.isArray(
                UserStore.userDetails?.additionalSettings
              )
                ? UserStore.userDetails?.additionalSettings
                : [];
              additionalSettings = additionalSettings?.filter(
                (setting) => setting?.name !== "2FactorAuthentication"
              );
              additionalSettings.push({
                name: "2FactorAuthentication",
                value:
                  !UserStore.userDetails?.additionalSettings?.find(
                    (setting) => setting?.name === "2FactorAuthentication"
                  )?.value ?? false,
              });
              const res = await UserStore.UpdateUserStatus({
                additionalSettings: additionalSettings,
              });
              if (res) {
                setIsEnabledForathunication(
                  UserStore.userDetails.additionalSettings?.find(
                    (setting) => setting?.name === "2FactorAuthentication"
                  )?.value ?? false
                );
              }
            }}
          />
        </div> */}

        <div className="flex flex-col">
          {JSON.parse(localStorage.getItem("user"))?.loginType === "email" && (
            <ChangePasswordForm />
          )}

          {/* <DisableAccount /> */}
          <DeleteAccount />
        </div>
      </div>
    </div>
  ));
};

export default MoreSettings;
